import { VFC } from 'react';
import { Container, Row, Col, Visible } from 'react-grid-system';
import styled from 'styled-components';
import { useSettings } from '../../contexts/settingsContext';
import { tCarrierItem } from '../../contexts/zod';
import Spacing from '../atoms/Spacing';
import Typography from '../atoms/Typography';
import RadioButton from '../molecules/RadioButton';
import TableItem from '../molecules/TableItem';
import FreigtSelectionForm from './form/FreigtSelectionForm';

interface Props {
  radius?: string;
}

export interface IFreightListItem extends tCarrierItem {
  onSelect: (key: string) => void;
  selected: string;
}

const ListWrapper = styled(Row)<Props>`
  background-color: white;
  border: 1px solid #e0e0e0;
  border-radius: ${({ radius }) => radius};
  padding: 2.4rem;

  margin-bottom: 2.4rem;
`;

const FreightImage = styled.img`
  max-width: 32px;
  object-fit: contain;
  aspect-ratio: 3/4;
`;

const FreightListItem: VFC<IFreightListItem> = ({
  onSelect,
  selected,
  ...rest
}) => {
  const { carrier, code, logoUrl, service } = rest;
  const { cornerRadius } = useSettings();
  const rowUid = `${code}-${service}`;

  const table = [
    {
      title: <Typography translateKey="carrier" variant="body1-semi-bold" />,
      value: carrier,
    },
    {
      title: (
        <Typography translateKey="carrier_service" variant="body1-semi-bold" />
      ),
      value: service,
    },
  ];

  return (
    <Container>
      <ListWrapper gutterWidth={16} radius={cornerRadius}>
        <Col xs={12} md="content" onClick={() => onSelect(rowUid)}>
          <RadioButton checked={selected === `${code}-${service}`} />
          <Visible xs sm md>
            <Spacing spacing={2} />
          </Visible>
        </Col>
        {logoUrl && (
          <Col xs={12} md="content">
            <FreightImage alt="freight company logo" src={logoUrl} />

            <Visible xs sm md>
              <Spacing spacing={3} />
            </Visible>
          </Col>
        )}
        {table.map((item) => (
          <Col key={item.value} xs={12} md="content">
            <Row nogutter>
              <TableItem title={item.title} value={item.value} />
            </Row>
            <Visible xs sm md>
              <Spacing spacing={3} />
            </Visible>
          </Col>
        ))}
        <Col xs={12}>
          {selected === rowUid && <FreigtSelectionForm {...rest} />}
        </Col>
      </ListWrapper>
    </Container>
  );
};

export default FreightListItem;
